/**
 * Generates a callback to be called when show all is pressed in the people to contact tabs, sends tealium tracking and onViewMore callback
 *
 * @param {object} params - Parameters
 * @param {string} params.parentScreenName - parent screen name dashboard or clients
 * @param {string} params.currentScreenName - the current screen name in the client to contact tabs
 * @param {function} params.onViewMore - a callback to call on view more
 * @param {function} params.sendEvent - a callback to send the tealium request
 *
 * @returns {function} - Callback - A function to be called when show all is pressed
 */

export function generateOnShowAllPress({
  parentScreenName,
  currentScreenName,
  onViewMore,
  sendEvent,
  lastPaidRank,
}: any) {
  return () => {
    onViewMore();
    if (parentScreenName) {
      sendEvent({
        previousScreenName: parentScreenName,
        currentScreenName: currentScreenName,
        lastPaidRank: lastPaidRank,
      });
    }
  };
}
